import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useFieldArray } from "react-hook-form";
import { useEmailStore } from "../store/emailStore";
import EmailRowWrapper from "../email-row-wrapper/EmailRowWrapper";
import Button from "../base/Button";
import { PlusIcon } from "../Icons/Icons";
import EmailFormModal from "../email-form-modal/EmailFormModal";
import { EmailDefaultLocale } from "../../constants/form-fields";
import RemoveEmailModal from "../remove-email-modal/RemoveEmailModal";
import { useToastWrapper } from "../../hooks/useToastWrapper";
import { hasError, hasMessageError } from "../../utils/utils";
import { APIErrorCodes, APIErrorMessages, MAX_EMAILS, } from "../../constants/profile";
import { useLocalizedString } from "@amzn/aws-marketing-identity-kit-localizations";
import Divider from "../base/Divider";
const EmailForm = ({ isEditing, control, profile, adapter, }) => {
    const { updateEmailStatus } = useEmailStore();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isdeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const { showErrorToast } = useToastWrapper();
    const [requestError, setrequestError] = useState("");
    const { t } = useLocalizedString();
    const { fields, remove } = useFieldArray({
        control,
        name: "emails",
    });
    const [isVerifying, setIsVerifying] = useState(false);
    const [currentEmail, setCurrentEmail] = useState("");
    const handleEmailUpdate = (originalEmail, newValue) => {
        updateEmailStatus(originalEmail, { email: newValue });
    };
    const handleTypeUpdate = (email, newType) => {
        updateEmailStatus(email, { type: newType });
    };
    const handleRemoveEmail = async (email) => {
        setCurrentEmail(email);
        setIsDeleteModalOpen(true);
    };
    const getButtonOptions = (email) => [
        {
            key: "Remove",
            value: "remove",
            onClick: () => handleRemoveEmail(email),
        },
    ];
    const onVerifyEmail = async (email) => {
        setCurrentEmail(() => email);
        setIsVerifying(true);
        setIsModalOpen(true);
        try {
            await adapter.RequestEmailVerification(email, EmailDefaultLocale);
        }
        catch (error) {
            if (error &&
                hasError(error, APIErrorCodes.TooManyRequests) &&
                hasMessageError(error, APIErrorMessages.TooManyRequests) &&
                !hasMessageError(error, APIErrorMessages.TooManyRequestsPerDay)) {
                setrequestError(APIErrorMessages.TooManyRequests);
                return;
            }
            if (error &&
                hasError(error, APIErrorCodes.TooManyRequests) &&
                hasMessageError(error, APIErrorMessages.TooManyRequestsPerDay)) {
                setrequestError(APIErrorMessages.TooManyRequestsPerDay);
                return;
            }
            onModalClose();
            showErrorToast(t("There was an error sending your verification code."));
        }
    };
    const showAddButton = isEditing && fields.length < MAX_EMAILS;
    const onModalClose = () => {
        setCurrentEmail("");
        setIsVerifying(false);
        setIsModalOpen(false);
        setIsDeleteModalOpen(false);
        setrequestError("");
    };
    const onRemoveModalClose = (index) => {
        remove(index);
        onModalClose();
    };
    return (_jsxs("div", { className: "flex flex-col gap-4 md:gap-8", children: [fields.map((field, index) => !field?.tag?.isUsernameEmail && (_jsxs(_Fragment, { children: [_jsx(EmailRowWrapper, { email: field, isVerifying: false, onEmailUpdate: (value) => handleEmailUpdate(field.email, value), onTypeUpdate: (value) => handleTypeUpdate(field.email, value), buttonOptions: getButtonOptions(field.email), control: control, name: `emails.${index}`, isEditing: isEditing, onVerifyEmail: onVerifyEmail, className: "items-center" }, field.id), _jsx(RemoveEmailModal, { isOpen: isdeleteModalOpen, onEmailRemoved: () => onRemoveModalClose(index), onClose: onModalClose, profile: profile, adapter: adapter, email: currentEmail }), _jsx("div", { className: "md:hidden", children: index !== fields.length - 1 && _jsx(Divider, {}) })] }))), _jsx(EmailFormModal, { isOpen: isModalOpen, onClose: onModalClose, profile: profile, adapter: adapter, isVerifying: isVerifying, email: currentEmail, error: requestError }), showAddButton && (_jsx("div", { className: "flex items-center md:px-4 space-x-4", children: _jsx(Button, { "data-testid": "add-email-button", variant: "tertiary", onClick: () => setIsModalOpen(true), className: "inline-flex items-center gap-2", children: _jsxs("div", { className: "inline-flex items-center gap-2", children: [_jsx(PlusIcon, {}), _jsx("p", { children: t("Add email") })] }) }) }))] }));
};
export default EmailForm;
//# sourceMappingURL=EmailForm.js.map